import React, { CSSProperties } from "react";
import whitelabel from "../whitelabel";

export default function IconFloorplan3D(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			width={props.size ?? "54"}
			height={props.size ?? "47"}
			style={props.style}
			viewBox="0 0 54 47"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="29.6429"
				height="29.6429"
				transform="matrix(0.866025 0.5 -0.866025 0.5 27 16.0898)"
				fill={whitelabel.palette.primary500}
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 -0.5 -4.36336e-08 -1 1.43262 30.9102)"
				fill={whitelabel.palette.primary800}
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 -0.5 -4.36336e-08 -1 1.43262 30.9102)"
				stroke={whitelabel.palette.secondary900}
				strokeLinejoin="round"
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 0.5 -5.96046e-08 1 1.43262 16.0898)"
				fill={whitelabel.palette.primary800}
				fillOpacity="0.8"
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 0.5 -5.96046e-08 1 1.43262 16.0898)"
				stroke={whitelabel.palette.secondary900}
				strokeLinejoin="round"
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 0.5 -5.96046e-08 1 27 1.26758)"
				fill={whitelabel.palette.primary800}
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 0.5 -5.96046e-08 1 27 1.26758)"
				stroke={whitelabel.palette.secondary900}
				strokeLinejoin="round"
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 -0.5 -4.36336e-08 -1 27 45.7324)"
				fill={whitelabel.palette.primary800}
				fillOpacity="0.8"
			/>
			<rect
				width="29.6429"
				height="14.8214"
				transform="matrix(0.866025 -0.5 -4.36336e-08 -1 27 45.7324)"
				stroke={whitelabel.palette.secondary900}
				strokeLinejoin="round"
			/>
			<path
				d="M1.41748 30.9099L27.0259 45.5598L52.6342 30.9099L52.6342 16.0896L27.0259 1.26953L1.41748 16.0896L1.41748 30.9099Z"
				stroke={whitelabel.palette.secondary900}
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
